export const PageIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.29531 1.88145C3.02953 1.88145 2.81406 2.09691 2.81406 2.3627V11.6377C2.81406 11.9035 3.02952 12.1189 3.29531 12.1189H10.7036C10.9694 12.1189 11.1849 11.9035 11.1849 11.6377V5.61478H7.93281C7.66703 5.61478 7.45156 5.39932 7.45156 5.13353V1.88145H3.29531ZM8.41406 2.56204L10.5043 4.65228H8.41406V2.56204ZM1.85156 2.3627C1.85156 1.56533 2.49795 0.918945 3.29531 0.918945H7.93281C8.06045 0.918945 8.18286 0.969648 8.27311 1.0599L12.0064 4.79323C12.0967 4.88349 12.1474 5.00589 12.1474 5.13353V11.6377C12.1474 12.4351 11.501 13.0814 10.7036 13.0814H3.29531C2.49795 13.0814 1.85156 12.4351 1.85156 11.6377V2.3627Z"
        fill="currentColor"
      />
    </svg>
  )
}
